import { Card, CardActionArea, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import React,{useState,useEffect} from 'react'
import Resumedata from '../../Utilitize/Resumedata'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './Projects.css'
import ImageGallery from '../../Components/ImageGallery/ImageGallery'

function Projects() {

  const [projectDialog,setProjectDialog]=useState(false);

        useEffect(()=>{
            Aos.init();
        },[])
    
    return (
        <Grid container className="section"  style={{paddingTop:"30px"}}>
            <title>Projects</title>
            {/* title */}
           <Grid item  className="section_title mb-4">
               <span></span>
               <h6 className="section_title_text">Projects</h6>  
            </Grid>


            <Grid item xs={12}>
                <Grid container spacing={2}>
                   {
                       Resumedata.protfolios.map((protfolio)=>{
                           return(
                              <Grid  item xs={12} sm={6} md={4} data-aos="fade-left"
                                  data-aos-anchor="#example-anchor"
                                  data-aos-offset="500"
                                  data-aos-duration="2000">
                                  <Card style={{backgroundColor:"#d4d1d1"}} className="customcard" onClick={()=>setProjectDialog(protfolio)}>
                                      <CardActionArea>
                                           <CardMedia className="customcard_image" image={protfolio.images} title={protfolio.title}/>
                                           <CardContent>
                                                <Typography className="customcard_title">{protfolio.title}</Typography>
                                           </CardContent>
                                      </CardActionArea>
                                  </Card>
                              </Grid>
                           )
                       })
                   }
                </Grid>
            </Grid>

            <Dialog fullWidth maxWidth={'md'} className="projectdialog" open={projectDialog} onClose={()=>setProjectDialog(false)}>
             <DialogTitle>{projectDialog.title}</DialogTitle>

             

             <DialogContent style={{height:"80vh"}}>
                 {
                     projectDialog.images && (

                        <ImageGallery images={projectDialog.images}/>
                     )
                 }




                 <Typography className="projectdialog_description">
                     <ul>
                     {projectDialog.description?.map((desc)=>{
                         return(
                             <li>{desc}</li>
                         )
                     })}
                     </ul>
                    
                     </Typography>
             </DialogContent>
             <DialogActions className="projectdialog_action">
                  {projectDialog.links?.map((link)=>{
                     return(
                         <a href={link.link} target="_blank" className="projectdialog_icon">{link.icon}{link.iconname}</a>
                     )
                  })}
             </DialogActions>
        </Dialog>

        </Grid>
    )
}

export default Projects
